export default __webpack_public_path__ + "static/media/iPhone.7497de8f.png";